<template>
  <div class="flex flex-wrap gap-4">
    <div class="flex-1 min-w-[200px]">
      <label class="label">Start Date:</label>
      <input
        type="date"
        :value="modelValue.startDate"
        :min="min"
        :max="modelValue.endDate || max"
        @input="$emit('update:modelValue', { ...modelValue, startDate: $event.target.value })"
        class="input"
      />
    </div>
    <div class="flex-1 min-w-[200px]">
      <label class="label">End Date:</label>
      <input
        type="date"
        :value="modelValue.endDate"
        :min="modelValue.startDate || min"
        :max="max"
        @input="$emit('update:modelValue', { ...modelValue, endDate: $event.target.value })"
        class="input"
      />
    </div>
  </div>
</template>

<script setup>
defineProps({
  modelValue: {
    type: Object,
    required: true
  },
  min: {
    type: String,
    default: null
  },
  max: {
    type: String,
    default: null
  }
})

defineEmits(['update:modelValue'])
</script>
